<template>
    <svg id="mind-map" class="flex-1" ref="markmap" :class="{dark : $theme.darkTheme}"></svg>
</template>

<script>
import { Transformer } from "markmap-lib";
import { Markmap, deriveOptions } from "markmap-view";

const transformer = new Transformer();

export default {
    name: "AiMindMap",
    props: {
        isActive: Boolean,
        content: { type: String, default: "" },
    },
    watch: {
        content(content, oldContent) {
            if (!content && oldContent) return this.destroyMindMap();
            this.setMindMap();
        },
    },
    mounted() {
        this.setMindMap();
    },
    beforeDestroy() {
        this.destroyMindMap();
    },
    methods: {
        async setMindMap() {
            const mindMapContent = this.content;

            if (!mindMapContent) return;
            if (this.mindMapInstance) this.mindMapInstance.destroy();

            const svgEl = this.$refs.markmap;
            if (!svgEl) return;

            const markmapOptions = deriveOptions({
                color: [this.$theme.primaryColor],
            });

            const instance = Markmap.create(svgEl, markmapOptions);
            this.mindMapInstance = instance;

            const { root } = transformer.transform(mindMapContent);
            // setData é assíncrono: o bounding box do conteúdo (state.rect) só
            // existe depois de um requestAnimationFrame interno, e o fit()
            // centraliza a partir dele. Chamar fit() por setTimeout corria
            // contra esse rAF — quando ganhava, o mapa ficava descentrado.
            await instance.setData(root);
            if (this.mindMapInstance !== instance) return;
            await instance.fit();
        },
        destroyMindMap() {
            if (this.mindMapInstance) {
                this.mindMapInstance.destroy();
                this.mindMapInstance = null;
            }
        },
    },
};
</script>

<style scoped>
#mind-map {
    display: block;
    width: 100%;
    height: 50vh;
}
</style>
